import cns from 'classnames';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';

export default class VerbHeading extends PureComponent {
    static propTypes = {
        hNumber: PropTypes.number.isRequired,
        defaultMessage: PropTypes.string,
        messageId: PropTypes.string,
        description: PropTypes.string,
        valuesToInject: PropTypes.object,
        className: PropTypes.string,
        formatIntl: PropTypes.bool,
        customMessage: PropTypes.string,
        styleNumber: PropTypes.string
    };

    _getHeadingTag = () => {
        const { hNumber } = this.props;
        const tags = {
            1: 'h1',
            2: 'h2',
            3: 'h3',
            4: 'h4',
            5: 'h5',
            6: 'h6'
        };
        return tags[hNumber];
    };

    _formatMessage = (messageId, defaultMessage, description, valuesToInject) => (
        <FormattedMessage
            id={messageId}
            defaultMessage={defaultMessage}
            description={description}
            values={valuesToInject}
        />
    );

    render() {
        const {
            defaultMessage,
            messageId = ' ',
            valuesToInject = {},
            description,
            className,
            formatIntl = true,
            customMessage = '',
            styleNumber = this.props.hNumber // this is for backward compatability. Once we apply accessibility methodologies headings should be separated from styling
        } = this.props;
        const HeadingTag = this._getHeadingTag();
        const messageToRender = formatIntl
            ? this._formatMessage(messageId, defaultMessage, description, valuesToInject)
            : customMessage;

        return <HeadingTag className={cns(className, `verb-title-${styleNumber}`)}>{messageToRender}</HeadingTag>;
    }
}
